import CustomHead from '@/components/Common/Layout/Head';
import { Layout } from '@/components/Common';
import { logPageView, logCommonView } from '@/lib/service';
import { EventSource } from '@/shared/constants/event';
import { useEffect } from 'react';
import { WEBSITE_URL } from '@/shared/constants';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import HelpVideos from '@/components/HelpVideos';

const HelpVideosPage = () => {
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: 'Help Videos | Pietra',
    });
    logCommonView(EventSource.HELP_VIDEOS, 'VIEW');
  }, []);

  return <HelpVideos />;
};

HelpVideosPage.getLayout = (page: React.ReactElement) => {
  const invisibleHeaderTags = (
    <div style={{ display: 'none' }}>
      <h1>Pietra Tutorials</h1>
      <h2>Watch step-by-step tutorials to get the most out of your Pietra experience</h2>
    </div>
  );

  return (
    <>
      <CustomHead
        title="Pietra Tutorials | Pietra"
        description="Watch step-by-step tutorials to get the most out of your Pietra experience"
        url={`${WEBSITE_URL}/help-videos`}
      />
      <Layout structured={SEO_META[SEO_META_PAGES.HELP_VIDEOS].jsonld({})}>
        {invisibleHeaderTags}
        {page}
      </Layout>
    </>
  );
};

export default HelpVideosPage;
